import DataRoom from './DataRoom';

export default DataRoom;
